import React from 'react';
import MainInfoTracLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/UserManagement/ManageAlerts';

function UserManagementManageAlerts() {
  return (
    <MainInfoTracLayout className="min-h-[100vh] bg-white" isOldPage>
      <Content />
    </MainInfoTracLayout>
  );
}

export default UserManagementManageAlerts;
